var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../hooks/requestHook';
import { column, dateColumn } from '../../hooks/useColumns';
import { warehouseHoliday as api } from '../../api';
import MaterialTable from '../MaterialTable';
import PageLayout from '../atoms/PageLayout';
import { useNotify } from '../../hooks/notificationHook';
import useFetch from '../../hooks/useFetch';
import { decamelize } from '../../utils/camelize';
import qs from 'qs';
import DateRangeFilter from '../molecules/DateRangeFilter';
import { useWarehouse } from '../../hooks/useWarehouse';
import { LinearProgress } from '@mui/material';
import EditDatePicker from '../MaterialTable/EditDatePicker';
var AdminWarehouseHolidaysPage = function () {
    var t = useTranslation().t;
    var notify = useNotify();
    var getAll = useRequest(api.getAll);
    var create = useRequest(api.create);
    var destroy = useRequest(api.destroy);
    var _a = useWarehouse(), warehousesLoading = _a.loading, warehouses = _a.warehouses;
    var urlQuery = React.useMemo(function () { return qs.parse(location.search.slice(1)); }, []);
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var defaultSort = React.useCallback(function (field) {
        var orderBy = urlQuery.orderBy;
        var orderDirection = urlQuery.orderDirection;
        var direction = 'asc';
        if (['asc', 'desc'].includes(orderDirection !== null && orderDirection !== void 0 ? orderDirection : ''))
            direction = orderDirection;
        if (field == orderBy)
            return direction;
    }, [urlQuery]);
    var renderDateRangeFilter = React.useCallback(function (props) { return React.createElement(DateRangeFilter, __assign({}, props)); }, []);
    var warehouseLookupItems = React.useMemo(function () {
        return warehouses.reduce(function (acc, cur) {
            acc[cur.id] = cur.name;
            return acc;
        }, {});
    }, [warehouses]);
    var columns = React.useMemo(function () { return [
        column('warehouse.id', {
            title: t('params.warehouse.name'),
            defaultSort: defaultSort('warehouse.id'),
            defaultFilter: defaultFilter('warehouse.id'),
            lookup: warehouseLookupItems,
        }),
        dateColumn('date', {
            filterComponent: renderDateRangeFilter,
            editComponent: EditDatePicker,
            initialEditValue: null,
            defaultSort: defaultSort('date'),
            defaultFilter: defaultFilter('date'),
        }),
    ]; }, [t, defaultSort, defaultFilter, renderDateRangeFilter, warehouseLookupItems]);
    var handleCreate = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        warehouse_holiday: {
                            warehouse_id: data.warehouse.id,
                            date: data.date,
                        },
                    };
                    return [4 /*yield*/, create(params)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        throw Error('error response');
                        return [2 /*return*/];
                    }
                    notify('success', [t('messages.createSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [create, notify, t]);
    var handleDelete = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, destroy({ id: data.id })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.deleteSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [destroy, notify, t]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'warehouse.id': {
                    q.warehouse_id_in = filter.value;
                    break;
                }
                case 'date': {
                    var field = decamelize(filter.column.field);
                    if (filter.value.startedAt) {
                        q["".concat(field, "_gteq")] = filter.value.startedAt;
                    }
                    if (filter.value.endedAt) {
                        q["".concat(field, "_lteq")] = filter.value.endedAt;
                    }
                    break;
                }
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            case 'warehouse.id':
                return 'warehouses.name';
            default:
                return decamelize(order);
        }
    }, []);
    var fetchWarehouseHoliday = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        buildOrder: buildOrder,
    });
    if (warehousesLoading)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.adminWarehouseHoliday.title') },
        React.createElement(MaterialTable, { model: "warehouseHoliday", columns: columns, data: fetchWarehouseHoliday, editable: {
                onRowAdd: handleCreate,
                onRowDelete: handleDelete,
            }, options: {
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                    maxWidth: 200,
                },
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
            }, detailPath: function (_a) {
                var id = _a.id;
                return "/admin/warehouses/".concat(id);
            } })));
};
export default AdminWarehouseHolidaysPage;
